import $ from "jquery";
import ScriptHelper from "base/ScriptHelper";
import {centerMap, MAP_STYLES} from "util/map";

let infowindow;

export function loadMultipleGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyALIV9KE7xv-qRbMO1TKxXExkuBO5yS6sQ").then(() => {
        loadMultipleMarkerMap($element);
    });
}

function loadMultipleMarkerMap($element) {
    let markers = {};

    if ($('.js-marker-locations').length > 0) {
        try {
            markers = JSON.parse($('.js-marker-locations').text());
        } catch (e) {
            console.log('Could not load map markers', e);
        }
    }

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    initMultipleMarker({
        marker_location: {
            lat: 52.276930,
            lng: -1.593410
        },
        marker_description: '113 West Street, \n' +
            'Warwick, Warwickshire, \n' +
            'CV34 6AH',
        marker_title: 'Park Cottage',
        marker_type: {value: 'main', label: ''}
    }, map)

    initMultipleMarker({
        marker_location: {
            lat: 52.279230,
            lng: -1.588496
        },
        marker_description: 'No trip to Warwick is complete without visiting our incredible castle!',
        marker_title: 'Warwick Castle',
        marker_type:  {value: 'castle', label: 'Castle'}
    }, map)

    initMultipleMarker({
        marker_location: {
            lat: 52.276517,
            lng: -1.593820
        },
        marker_description: 'Warwick Castle Entrance and Car Park',
        marker_title: 'Castle Entrance',
        marker_type:  {value: 'castle', label: 'Castle'}
    }, map)

    if (markers.length > 0) {
        markers.forEach((marker) => {
            initMultipleMarker(marker, map);
        });
    }

    centerMap(map);
}

function initMultipleMarker(markerData, map) {
    let latLng = {
        lat: parseFloat(markerData.marker_location.lat),
        lng: parseFloat(markerData.marker_location.lng)
    };
    let type = markerData.marker_type.value;
    let category = markerData.marker_type.label;

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
    });

    if (type === 'main') {
        marker.setIcon({
            url: '/wp-content/themes/park-cottage/images/svg/' + type + '-marker.svg',
            scaledSize: new google.maps.Size(45, 65),
            labelOrigin: new google.maps.Point(22, 65),
        })
    } else {
        marker.setIcon({
            url: '/wp-content/themes/park-cottage/images/svg/' + type + '-marker.svg',
            scaledSize: new google.maps.Size(30, 43),
            labelOrigin: new google.maps.Point(22, 65),
        })
    }

    marker.addListener('click', function () {
        if (infowindow) infowindow.close();
        this.setAnimation(null);

        let $content = (
            eotwJSXFactory('div', {className: "map-tooltip map-tooltip--" + type}, [
                type !== 'main' ? (eotwJSXFactory('div', {className: "map-tooltip__subtitle"}, [category])) : '',
                eotwJSXFactory('h2', {className: "heading map-tooltip__heading"}, [markerData.marker_title]),
                eotwJSXFactory('p', null, [markerData.marker_description]),
                type === 'main' ? (eotwJSXFactory('a', {className: "map-tooltip__link", target: "_blank", rel: "noreferrer", href: 'https://www.google.com/maps/dir/?api=1&destination=' + markerData.marker_title}, ["Get directions"])) : ''
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0]
        });

        setTimeout(function () {
            $('.gm-style-iw-a').addClass('active');
        }, 100)

        infowindow.open(map, marker);
    });

    map.markers.push(marker);
}